module.exports = "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiMDFkYTRjYWY0NjNkMzA3YjU3MTBmNjBmYWJmOGQ4MzAucG5nIjs="